<template>
  <div class="todayAcountDetailBox">
    <div class="todayAcountDetail">
      <div class="top">
        <div @click="goBack">
          <md-icon name="arrow-left" size="xs" style="font-size: 0.24rem;"></md-icon>
          <span>日订单列表</span>
        </div>
        <!-- <div>打印</div> -->
      </div>
      <div class="statusPart">
        <div class="status">
          <div
            v-for="(item,index) in searchList"
            :key="index"
            @click="switchStatus(index)"
            :class="{active:index==nowStatus}"
          >{{item.name}}</div>
        </div>

        <div class="searchPart">
          <div class="name">
            <md-icon name="search" size="xs" style="font-size: 0.24rem;"></md-icon>
            <input type="text" v-model="dataQuery.name" placeholder="搜索买家姓名" @blur="getSearch" />
            <div @click="clearName" v-if="dataQuery.name">
              <md-icon name="wrong" size="md" style="font-size: 0.18rem;padding:0.04rem;color:#666"></md-icon>
            </div>
          </div>
          <div class="time">
            <Calendar v-model="data_picker" @change="changeTime"></Calendar>
          </div>
        </div>
      </div>
      <div class="total" v-if="list.length>0">
        <div v-if="nowStatus==0 || nowStatus==1">
          <span>订单金额：</span>
          <span class="money">{{sum_totle.order_amount_total*1 || 0}}</span>
          <span>元，</span>
        </div>
        <div v-if="nowStatus==1">
          <span>赊欠金额：</span>
          <span class="money">{{sum_totle.sum_credit_amount_total*1 || 0}}</span>
          <span>元，</span>
        </div>
        <div v-if="nowStatus==1">
          <span>未还金额：</span>
          <span class="money">{{sum_totle.last_credit_totle*1 || 0}}</span>
          <span>元，</span>
        </div>

        <div v-if="nowStatus==2">
          <span>还款金额：</span>
          <span class="money">{{sum_totle.sum_annal_total*1 || 0}}</span>
          <span>元</span>
        </div>
        <div v-if="nowStatus==3">
          <span>作废金额：</span>
          <span class="money">{{sum_totle.order_amount_total*1 || 0}}</span>
          <span>元</span>
        </div>
        <div
          v-if="nowStatus==0 || nowStatus==1 || nowStatus==2 || nowStatus==3 || nowStatus==4"
        >合计单数：{{sum_totle.sum_total ||0}}单</div>
      </div>
      <div class="listPart" v-if="list.length>0">
        <div class="title">
          <span>
            <span v-if="nowStatus==0 || nowStatus==1  || nowStatus==3 || nowStatus==4">下单时间</span>
            <span v-if="nowStatus==2">还款时间</span>
          </span>
          <span>
            <span v-if="nowStatus==0 || nowStatus==1 || nowStatus==3">日单号</span>
            <span v-if="nowStatus==2">买家姓名</span>
            <span v-if="nowStatus==4">修改后日单号</span>
          </span>
          <span>
            <span v-if="nowStatus==0 || nowStatus==1">买家姓名</span>
            <span v-if="nowStatus==2">订单金额</span>

            <span v-if="nowStatus==3">作废时间</span>
            <span v-if="nowStatus==4">改单时间</span>
          </span>
          <span>
            <span v-if="nowStatus==0">商品金额</span>
            <span v-if="nowStatus==1">订单金额</span>
            <span v-if="nowStatus==2">还款金额</span>

            <span v-if="nowStatus==3">买家姓名</span>
            <span v-if="nowStatus==4">买家姓名</span>
          </span>
          <span>
            <span v-if="nowStatus==0">订单金额</span>
            <span v-if="nowStatus==1">赊欠金额</span>
            <span v-if="nowStatus==2">未还欠款</span>

            <span v-if="nowStatus==3">订单金额</span>
            <span v-if="nowStatus==4">修改前金额</span>
          </span>
          <!-- :class="{cerditAcount:nowStatus==1}" -->
          <span>
            <span v-if="nowStatus==0">优惠金额</span>
            <span v-if="nowStatus==1">未还金额</span>
            <span v-if="nowStatus==2">还款优惠</span>
            <span v-if="nowStatus==3">退款方式</span>
            <span v-if="nowStatus==4">修改后金额</span>
          </span>
          <span>
            <span v-if="nowStatus==0 || nowStatus==1">收银员</span>
            <span v-if="nowStatus==2 || nowStatus==3 || nowStatus==4">操作员</span>
          </span>
        </div>
        <div class="listBox">
          <div class="list">
            <md-scroll-view
              ref="scrollView"
              :auto-reflow="true"
              :bouncing="false"
              :scrolling-x="false"
              @end-reached="$_onEndReached"
            >
              <div class="item" v-for="(item,i) in list" :key="i">
                <span>
                  <span
                    v-if="nowStatus==0 || nowStatus==1 || nowStatus==2 || nowStatus==3"
                  >{{item.create_time}}</span>
                  <span v-if="nowStatus==4">{{item.create_time1}}</span>
                </span>
                <span>
                  <span v-if="nowStatus==0 || nowStatus==1 || nowStatus==3">{{item.day_num}}</span>
                  <span v-if="nowStatus==2">{{item.name}}</span>
                  <span v-if="nowStatus==4">{{item.day_num}}</span>
                </span>
                <span>
                  <span v-if="nowStatus==0 || nowStatus==1">{{item.name}}</span>
                  <span v-if="nowStatus==2">{{item.order_amount*1}}元</span>
                  <span v-if="nowStatus==3">{{item.update_time}}</span>
                  <span v-if="nowStatus==4">{{item.create_time}}</span>
                </span>
                <span>
                  <span v-if="nowStatus==0">{{item.receivables*1}}元</span>
                  <span v-if="nowStatus==1">{{item.order_amount*1}}元</span>
                  <span v-if="nowStatus==2">{{item.annal*1 || 0}}元</span>

                  <span v-if="nowStatus==3">{{item.name}}</span>
                  <span v-if="nowStatus==4">{{item.name}}</span>
                </span>
                <span>
                  <span v-if="nowStatus==0">{{item.order_amount*1}}元</span>
                  <span v-if="nowStatus==1">{{item.credit_amount*1}}元</span>
                  <span v-if="nowStatus==2">{{item.last_credit*1 || 0}}元</span>

                  <span v-if="nowStatus==3">{{item.order_amount*1 || 0}}元</span>
                  <span v-if="nowStatus==4">{{item.order_amount1*1}}元</span>
                </span>
                <!-- :class="{cerditAcount:nowStatus==1}" -->
                <span>
                  <span v-if=" nowStatus==0 && item.discount<=0">{{Math.abs(item.discount*1)}}元</span>
                  <span v-if="nowStatus==0 && item.discount>0">
                    {{-item.discount*1}}元
                    <span style="color:#999;font-size:0.16rem">（多收）</span>
                  </span>
                  <span v-if="nowStatus==1">{{item.last_credit*1 || 0}}元</span>
                  <span v-if="nowStatus==2">{{item.annal_discount*1 || 0}}元</span>

                  <span v-if="nowStatus==3">
                    <span v-if="item.pay_type==1">现金</span>
                    <span v-if="item.pay_type==2">现金</span>
                    <span v-if="item.pay_type==3">现金</span>
                    <span v-if="item.pay_type==4">现金</span>
                    <span v-if="item.pay_type==51 || item.pay_type==52 || item.pay_type==53">POS</span>
                  </span>
                  <span v-if="nowStatus==4">{{item.order_amount*1}}元</span>
                </span>
                <span
                  v-if="nowStatus==0 || nowStatus==1 || nowStatus==2 || nowStatus==3 || nowStatus==4"
                >{{item.realname}}</span>
              </div>
              <md-scroll-view-more
                :finished-text="list.length>0?'全部已加载':'暂无数据'"
                slot="more"
                :is-finished="isFinished"
              ></md-scroll-view-more>
            </md-scroll-view>
          </div>
        </div>
        <div class="totalAcount">
          <span>合计</span>
          <span></span>
          <span></span>
          <span>
            <span v-if="nowStatus==0">{{sum.sum_receivables*1 || 0}}元</span>
            <span v-if="nowStatus==1">{{sum.sum_order_amount*1}}元</span>
            <span v-if="nowStatus==2">{{sum.sum_annal*1}}元</span>
          </span>
          <span>
            <span v-if="nowStatus==0">{{sum.sum_order_amount*1 || 0}}元</span>
            <span v-if="nowStatus==1">{{sum.sum_credit_amount*1}}元</span>
            <span v-if="nowStatus==2">{{sum.sum_last_credit*1}}元</span>

            <span v-if="nowStatus==3">{{sum.sum_order_amount*1}}元</span>
          </span>
          <!-- :class="{cerditAcount:nowStatus==1}" -->
          <span>
            <span v-if="nowStatus==0">{{Math.abs(sum.sum_discount*1) || 0}}元</span>
            <span v-if="nowStatus==1">{{sum.sum_last_credit*1}}元</span>
            <span v-if="nowStatus==2">{{sum.sum_annal_discount*1}}元</span>
            <span v-if="nowStatus==4">{{sum.sum_order_amount*1}}元</span>
          </span>
          <span></span>
        </div>
      </div>
      <div class="empty" v-if="list.length==0">暂无数据</div>
    </div>
  </div>
</template>
<script>
import { today_acount_detail } from "@/api/work/acount/todayAcount";
import { timestampToDate } from "@/utils/timestamp";
import Calendar from "@/components/Calendar";
export default {
  name: "todayAcountDetail",
  components: {
    Calendar,
  },
  data() {
    return {
      searchList: [
        {
          name: "已结清订单",
          index: 0,
        },
        {
          name: "赊欠账单",
          index: 1,
        },
        {
          name: "历史还款",
          index: 2,
        },
        {
          name: "作废订单",
          index: 3,
        },
        {
          name: "修改订单",
          index: 4,
        },
        // {
        //   name: "退单订单",
        //   index: 0,
        // },
      ],
      dataQuery: {
        status: "",
        is_credit: "",
        name: "",
        orderby: "create_time",
        desc: "",
        s: "",
        e: "",
        page: 1,
        pagesize: 55,
      },
      data_picker: [],
      searchName: "",
      list: [],
      sum_totle: {
        order_amount_total: "",
        sum_total: "",
        sum_annal_total: "",
        sum_credit_amount_total: "",
        last_credit_totle: "",
        //总合计
      },
      sum: {
        sum_num: "",
        sum_receivables: "",
        sum_order_amount: "",
        sum_discount: "",
        sum_annal: "",
        sum_last_credit: "",
        sum_annal_discount: "",
        sum_credit_amount: "",
        //合计
      },
      nowStatus: 0,
      isFinished: false,
    };
  },
  created() {
    if (this.$route.query.status == 0) {
      this.dataQuery.status = 1;
    } else if (this.$route.query.status == 1) {
      this.dataQuery.status = 2;
    } else if (this.$route.query.status == 2) {
      this.dataQuery.status = "";
      this.dataQuery.is_credit = 1;
    } else if (this.$route.query.status == 3) {
      this.dataQuery.status = 3;
    } else if (this.$route.query.status == 4) {
      this.dataQuery.status = 4;
    }
    this.nowStatus = this.$route.query.status;
    this.getList();
  },
  mounted() {},
  methods: {
    switchStatus(index) {
      this.nowStatus = index;
      this.dataQuery.is_credit = "";
      this.dataQuery.page = 1;
      if (this.nowStatus == 0) {
        this.dataQuery.status = 1;
      } else if (this.nowStatus == 1) {
        this.dataQuery.status = 2;
      } else if (this.nowStatus == 2) {
        this.dataQuery.status = "";
        this.dataQuery.is_credit = 1;
      } else if (this.nowStatus == 3) {
        this.dataQuery.status = 3;
      } else if (this.nowStatus == 4) {
        this.dataQuery.status = 4;
      }

      this.getList();
    },
    //获取列表数据
    getList() {
      if (this.dataQuery.page == 1) {
        this.list = [];
      }
      today_acount_detail(this.dataQuery).then((res) => {
        if (res.code == 200) {
          this.sum_totle.order_amount_total =
            res.data.list.sum_totle.order_amount_total || 0;
          this.sum_totle.sum_total = res.data.list.sum_totle.sum_total || 0;
          this.sum_totle.sum_annal_total =
            res.data.list.sum_totle.sum_annal_total || 0;
          this.sum_totle.sum_credit_amount_total =
            res.data.list.sum_totle.sum_credit_amount_total || 0;
          this.sum_totle.last_credit_totle =
            res.data.list.sum_totle.last_credit_totle || 0;
          // 合计
          this.sum.sum_num = res.data.list.sum.sum_num || 0;
          this.sum.sum_receivables = res.data.list.sum.sum_receivables || 0;
          this.sum.sum_order_amount = res.data.list.sum.sum_order_amount || 0;
          this.sum.sum_discount = res.data.list.sum.sum_discount || 0;
          this.sum.sum_annal = res.data.list.sum.sum_annal || 0;
          this.sum.sum_last_credit = res.data.list.sum.sum_last_credit || 0;
          this.sum.sum_credit_amount = res.data.list.sum.sum_credit_amount || 0;
          this.sum.sum_annal_discount =
            res.data.list.sum.sum_annal_discount || 0;
          this.list = this.list.concat(res.data.list.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.dataQuery.page++;
          }
        }
      });
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },
    //搜索买家姓名
    getSearch() {
      this.list = [];
      this.dataQuery.page = 1;
      this.getList();
    },
    //选择时间
    changeTime(e) {
      console.log("===", e);
      if (this.data_picker) {
        this.dataQuery.s = timestampToDate(this.data_picker[0]);
        this.dataQuery.e = timestampToDate(this.data_picker[1]);
      } else {
        this.dataQuery.s = "";
        this.dataQuery.e = "";
      }
      this.dataQuery.page = 1;
      this.list = [];
      this.getList();
    },
    //删除搜索名称
    clearName() {
      this.list = [];
      this.dataQuery.page = 1;
      this.dataQuery.name = "";
      this.getList();
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.todayAcountDetailBox {
  height: 100%;
  padding: 0.1rem;
  padding-bottom: 0;
}
.todayAcountDetail {
  padding: 0.2rem;
  background: #fff;
  border-radius: 0.1rem;
  height: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding-bottom: 0;
  box-sizing: border-box;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.1rem;
    height: 0.45rem;
    > div:nth-of-type(1) {
      color: #31b158;
      margin-bottom: 0.14rem;
      font-size: 0.24rem;
      font-weight: bold;
    }
    > div:nth-of-type(2) {
      width: 1rem;
      height: 0.36rem;
      background: #31b158;
      border-radius: 0.04rem;
      color: #fff;
      text-align: center;
      line-height: 0.36rem;
    }
  }
  .statusPart {
    display: flex;
    margin-bottom: 0.2rem;
    align-items: center;
    justify-content: space-between;
    height: 0.4rem;
    .status {
      display: flex;
      align-items: center;
      > div {
        width: 1.2rem;
        height: 0.36rem;
        text-align: center;
        line-height: 0.34rem;
        border: 0.01rem solid #31b158;
        border-radius: 0.04rem;
        margin-right: 0.1rem;
        color: #31b158;
        font-size: 0.2rem;
      }
      .active {
        background: #31b158;
        color: #fff;
        border-color: #31b158;
      }
    }

    .searchPart {
      display: flex;
      align-items: center;
      height: 0.36rem;
      margin-right: 0.2rem;
      .name {
        border: 0.01rem solid #e5e5e5;
        width: 2.6rem;
        height: 0.36rem;
        display: flex;
        align-items: center;
        color: #999;
        padding: 0.08rem 0.1rem;
        margin-right: 0.1rem;
        > div {
          width: 0.26rem;
          height: 0.26rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.2);
          margin-right: 0.04rem;
        }
        input {
          padding-left: 0.16rem;
          width: 100%;
          font-size: 0.2rem;
        }
      }
    }
  }

  .total {
    display: flex;
    align-items: center;
    font-size: 0.22rem;
    margin: 0 0.22rem;
    color: #404040;
    margin-bottom: 0.2rem;
    height: 0.3rem;
    > div:nth-of-type(1) {
      margin-right: 0.2rem;
    }
    .money {
      color: #31b158;
    }
  }
  .listPart {
    height: calc(100% - 0.45rem - 0.4rem - 0.2rem - 0.3rem - 0.2rem);
    margin: 0 0.22rem;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.68rem;
      border-top: 0.01rem solid #e5e5e5;
      > span {
        color: #555;
        font-size: 0.22rem;
        font-weight: bold;
        text-align: center;
      }
      > span:nth-of-type(1) {
        width: 1.2rem;
      }
      > span:nth-of-type(2) {
        width: 1.4rem;
      }
      > span:nth-of-type(3) {
        width: 1.6rem;
      }
      > span:nth-of-type(4) {
        width: 1.8rem;
      }
      > span:nth-of-type(5) {
        width: 1.8rem;
      }
      > span:nth-of-type(6) {
        width: 1.8rem;
      }
      .cerditAcount {
        width: 0rem !important;
      }
      > span:nth-of-type(7) {
        width: 1.2rem;
      }
    }
    .listBox {
      height: calc(100% - 0.68rem - 0.68rem);
      .list {
        height: 100%;
        font-size: 0.18rem;
        .item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 0.6rem;
          border-top: 0.01rem solid #e5e5e5;
          > span {
            text-align: center;
          }
          > span:nth-of-type(1) {
            width: 1.2rem;
          }
          > span:nth-of-type(2) {
            width: 1.4rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          > span:nth-of-type(3) {
            width: 1.6rem;
          }
          > span:nth-of-type(4) {
            width: 1.8rem;
          }
          > span:nth-of-type(5) {
            width: 1.8rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          > span:nth-of-type(6) {
            width: 1.8rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .cerditAcount {
            width: 0rem !important;
          }
          > span:nth-of-type(7) {
            width: 1.2rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }

    .totalAcount {
      height: 0.68rem;
      border-bottom: 0.01rem solid #e5e5e5;
      border-top: 0.01rem solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > span {
        color: #404040;
        font-weight: bold;
        font-size: 0.22rem;
        text-align: center;
      }
      > span:nth-of-type(1) {
        width: 1.2rem;
      }
      > span:nth-of-type(2) {
        width: 1.4rem;
      }
      > span:nth-of-type(3) {
        width: 1.6rem;
      }
      > span:nth-of-type(4) {
        width: 1.8rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      > span:nth-of-type(5) {
        width: 1.8rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      > span:nth-of-type(6) {
        width: 1.8rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .cerditAcount {
        width: 0rem !important;
      }
      > span:nth-of-type(7) {
        width: 1.2rem;
        text-align: right;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .empty {
    text-align: center;
    height: calc(
      100% - 0.45rem - 0.4rem - 0.36rem - 0.36rem - 0.36rem - 0.3rem
    );
    color: #999;
  }
}
</style>
<style lang="less">
.time {
  .calendar_select_box {
    width: 2.6rem !important;
    border: 0.01rem solid #e5e5e5 !important;
    background: #fff !important;
  }
}
</style>
    
